import { Injectable, inject } from '@angular/core';
import { WebNotificationInbox } from '@tcc-mono/vandijk/shared/data-access/models';
import { NotificationService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable, Subject, merge, of, timer } from 'rxjs';
import { catchError, map, shareReplay, switchMap, tap } from 'rxjs/operators';

const EMPTY_INBOX: WebNotificationInbox = {
  unhandled: [],
  handled: [],
  unhandled_count: 0
};

@Injectable({
  providedIn: 'root'
})
export class WebNotificationsState {
  private readonly _api = inject(NotificationService);
  private readonly _reload$ = new Subject<void>();

  public readonly inbox$: Observable<WebNotificationInbox> = merge(
    timer(0, 30_000),
    this._reload$
  ).pipe(
    switchMap(() =>
      this._api.getWebInbox().pipe(
        catchError(() => of(EMPTY_INBOX))
      )
    ),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public readonly count$: Observable<number> = this.inbox$.pipe(
    map((inbox) => inbox.unhandled_count)
  );

  public refresh(): void {
    this._reload$.next();
  }

  public handle(id: number): Observable<unknown> {
    return this._api.handle(id).pipe(
      tap(() => this.refresh())
    );
  }
}
